"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAltText = exports.getGifWidth = exports.getGifHeight = exports.getBestRenditionUrl = exports.getBestRendition = exports.getSpecificRendition = void 0;
var collections_1 = require("./collections");
var bestfit_1 = __importDefault(require("./bestfit"));
var webp_check_1 = require("./webp-check");
exports.getSpecificRendition = function (_a, renditionLabel, isStill, useVideo) {
    var images = _a.images, isSticker = _a.is_sticker;
    if (isStill === void 0) { isStill = false; }
    if (useVideo === void 0) { useVideo = false; }
    if (!images || !renditionLabel)
        return '';
    isStill = isStill && !useVideo;
    // @ts-ignore come back to this
    var rendition = images["" + renditionLabel + (isStill ? '_still' : '')];
    if (rendition) {
        if (isSticker || isStill) {
            return rendition.url;
        }
        var webP = webp_check_1.SUPPORTS_WEBP && rendition.webp;
        return useVideo ? rendition.mp4 : webP || rendition.url;
    }
    return '';
};
var getRenditions = function (type, images, video) {
    return type === 'video' && video && video.previews && !Object.keys(images).length ? video.previews : images;
};
exports.getBestRendition = function (images, gifWidth, gifHeight, scaleUpMaxPixels) {
    var checkRenditions = collections_1.pick(images, [
        'original',
        'fixed_width',
        'fixed_height',
        'fixed_width_small',
        'fixed_height_small',
    ]);
    var testImages = Object.entries(checkRenditions).map(function (_a) {
        var renditionName = _a[0], val = _a[1];
        return (__assign({ renditionName: renditionName }, val));
    });
    return bestfit_1.default(testImages, gifWidth, gifHeight, scaleUpMaxPixels);
};
exports.getBestRenditionUrl = function (_a, gifWidth, gifHeight, options) {
    var images = _a.images, video = _a.video, type = _a.type;
    if (options === void 0) { options = { isStill: false, useVideo: false }; }
    if (!gifWidth || !gifHeight || !images)
        return '';
    var useVideo = options.useVideo, isStill = options.isStill, scaleUpMaxPixels = options.scaleUpMaxPixels;
    var renditions = getRenditions(type, images, video);
    var renditionName = exports.getBestRendition(renditions, gifWidth, gifHeight, scaleUpMaxPixels).renditionName;
    // still, video, webp or gif
    var key = "" + renditionName + (isStill && !useVideo ? '_still' : '');
    var rendition = renditions[key];
    var match = useVideo ? rendition.mp4 : webp_check_1.SUPPORTS_WEBP && rendition.webp ? rendition.webp : rendition.url;
    return (match || '');
};
exports.getGifHeight = function (_a, gifWidth) {
    var images = _a.images;
    var fixed_width = images.fixed_width;
    if (fixed_width) {
        var width = fixed_width.width, height = fixed_width.height;
        var aspectRatio = width / height;
        return Math.round(gifWidth / aspectRatio);
    }
    return 0;
};
exports.getGifWidth = function (_a, gifHeight) {
    var images = _a.images;
    var fixed_width = images.fixed_width;
    if (fixed_width) {
        var width = fixed_width.width, height = fixed_width.height;
        var aspectRatio = width / height;
        return Math.round(gifHeight * aspectRatio);
    }
    return 0;
};
/**
 * GIF Text - Alt Text: Generates alt text for
 * GIF images based on username and tags.
 * @prop  {Gif}
 * @return {String} GIF alt text.
 */
exports.getAltText = function (_a) {
    var user = _a.user, _b = _a.tags, tags = _b === void 0 ? [] : _b, _c = _a.is_sticker, is_sticker = _c === void 0 ? false : _c, _d = _a.title, title = _d === void 0 ? '' : _d;
    if (title) {
        return title;
    }
    var username = (user && user.username) || '';
    var filteredTags = collections_1.take(collections_1.without(tags, ['transparent']), username ? 4 : 5);
    return "" + (username ? username + " " : "") + filteredTags.join(' ') + " " + (is_sticker ? 'Sticker' : 'GIF');
};
//# sourceMappingURL=gif-utils.js.map